import { Component, ApplicationRef } from '@angular/core';


export class MinimalizeComponent {

  constructor(private applicationRef:ApplicationRef) {}

  minimaliza() {
    this.applicationRef.components[0].instance.minimalize();
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[leaf-layout-minimalize]',
  template: `
  <a class="navbar-minimalize minimalize-styl-2 btn btn-primary" (click)="minimaliza()"><i class="fa fa-bars"></i> </a>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ApplicationRef, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
